import React, { useEffect, useState } from 'react';
import { Amplify } from 'aws-amplify';
import awsmobile from '../aws-exports';
import { get, ApiError } from 'aws-amplify/api';
import { Link } from 'react-router-dom';

import './DataList.css';

Amplify.configure(awsmobile);

// Function to convert HH:MM:SS to total seconds
function convertTimeToSeconds(timeStr) {
    const [hours, minutes, seconds] = String(timeStr || '0:0:0').split(':').map(Number);
    return (hours * 3600) + (minutes * 60) + seconds;
}

const SpaceTrackList = () => {
    const [spaces, setSpaces] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        async function fetchSpaces() {
            try {
                const restOperation = get({
                    apiName: 'spaces', // Replace 'spacesApi' with your actual API name
                    path: '/spaces'
                });
                const { body } = await restOperation.response;
                const jsonResponse = await body.json();

                // Sort the spaces by worked_time in descending order
                const sortedSpaces = jsonResponse.sort((a, b) => {
                    const timeA = convertTimeToSeconds(a.worked_time);
                    const timeB = convertTimeToSeconds(b.worked_time);
                    return timeB - timeA;
                });

                setSpaces(sortedSpaces);
                setLoading(false);
            } catch (e) {
                console.log('GET call failed:', e);
                if (e instanceof ApiError && e.response) {
                    const errorResponse = JSON.parse(e.response.body);
                    console.error('Error response:', errorResponse);
                    setError(`Error: ${errorResponse.message}`);
                } else {
                    setError('Failed to fetch spaces');
                }
                setLoading(false);
            }
        }

        fetchSpaces();
    }, []);

    const mostLogged = spaces.reduce((max, s) => Math.max(max, convertTimeToSeconds(s.worked_time)), 0);

    const header = (
        <div className="page-header">
            {/* "Spaces" is raw ClickUp vocabulary; say what it means to the reader. */}
            <h2 className="page-title">Time by Project</h2>
            <p className="page-subtitle">
                Time tracked against each ClickUp space this week, busiest first.
            </p>
        </div>
    );

    if (loading) return <>{header}<p className="loading-state" role="status">Loading projects…</p></>;
    if (error) return <>{header}<p className="error-state" role="alert">{error}</p></>;
    if (!spaces.length) {
        return <>{header}<p className="empty-state">No time has been tracked against any project this week.</p></>;
    }

    return (
        <div className="spaces-container">
            {header}
            <ul className="data-list">
                {spaces.map((space, index) => {
                    const secs = convertTimeToSeconds(space.worked_time);
                    return (
                        <li key={space.id}>
                            <Link to={`/spaces/${space.id}`} className="data-row">
                                <div className="data-row-top">
                                    <span className="data-index">{index + 1}</span>
                                    <span className="data-name">{space.name}</span>
                                    <span className="data-metric">{space.worked_time}</span>
                                </div>
                                <div className="data-sub">
                                    <span className="data-sub-label">Bug time</span>
                                    <span className="data-sub-value">{space.type_bug_time}</span>
                                    <span className="data-sub-label">
                                        ({space.type_bug_time_percentage} of this project's time)
                                    </span>
                                </div>
                                <div className="data-bar-track">
                                    <div
                                        className="data-bar-fill"
                                        style={{
                                            width: mostLogged ? `${(secs / mostLogged) * 100}%` : '0%',
                                            background: 'var(--accent)',
                                        }}
                                    />
                                </div>
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default SpaceTrackList;
